<p-toast />

<nav class="user-navbar">
    <div class="navbar-content">
        <!-- Left: avatar + user info -->
        <div class="navbar-user">
            <div class="navbar-avatar" [class.navbar-avatar--clickable]="!!photoUrl && !isUploading && !photoUploading" (click)="openPhotoModal()">
                @if (isUploading || photoUploading) {
                    <i class="pi pi-spin pi-spinner" style="color:white; font-size:1.2rem;"></i>
                } @else if (photoUrl) {
                    <img [src]="photoUrl" alt="Foto de perfil" class="navbar-avatar-img" />
                } @else {
                    <span>{{ userAuth.nombre | slice:0:1 }}</span>
                }
            </div>
            <div class="navbar-info">
                <span class="navbar-name">{{ userAuth.nombre }}</span>
                <span class="navbar-meta">{{ userAuth.entidad }}{{ userAuth.sede ? ' - ' + userAuth.sede : '' }}</span>
            </div>
        </div>

        <!-- Right: logout -->
        <button
            pButton
            type="button"
            icon="pi pi-sign-out"
            label="Salir"
            class="btn-logout"
            (click)="logout()"
        ></button>
    </div>
</nav>

<input #fileInput type="file" accept="image/*" class="hidden" (change)="onFileSelected($event)" />

@if (!photoUrl) {
    <div class="mx-4 mt-3">
        <app-foto-perfil
            [userId]="userAuth.id"
            [photoUrl]="null"
            [nombre]="userAuth.nombre"
            size="md"
            (photoUpdated)="onFotoPerfilUpdated($event)"
        />
    </div>
}

<p-dialog
    header="Foto de perfil"
    [modal]="true"
    [(visible)]="showPhotoModal"
    [style]="{ width: '22rem' }"
    [breakpoints]="{ '640px': '90vw' }"
    [draggable]="false"
    [resizable]="false"
>
    <div class="photo-modal-body">
        @if (isUploading) {
            <div class="photo-modal-spinner">
                <p-progressSpinner strokeWidth="4" animationDuration=".8s" />
                <span class="photo-modal-spinner-label">Subiendo foto...</span>
            </div>
        } @else {
            <img [src]="photoUrl" alt="Foto de perfil" class="photo-modal-img" />
            <p-button
                label="Cambiar foto"
                icon="pi pi-camera"
                [outlined]="true"
                severity="secondary"
                styleClass="photo-modal-btn"
                (click)="triggerFileInput()"
            />
        }
    </div>
</p-dialog>
